"use strict";
function Tabs(selector) {
	this.startBlock = selector;
	var navigation = $(this.startBlock).find('li > a');
	var activeElement;
	// console.log(this.navigation);
	//проверяем на наличие активных полей
	navigation.each(function(number,element) {
		if($(element).hasClass('activeTebs')) {
			$(element).addClass('active');
			$($(element).attr('href')).addClass('active');
			activeElement = $($(element).attr('href'));
			// console.log(this.activeElement );
		}
	});
	navigation.each(function (number,element) {
		$(element).on('click', function (e) {
			e.preventDefault();
			//удалить активные классы в старых елементах
			$(navigation).removeClass('active');
			$(activeElement).removeClass('active');
			//добавить классы активным елементам
			$(this).addClass('active');
			$($(this).attr('href')).addClass('active');
			activeElement = $(this).attr('href');
			console.log(this.parentNode.parentNode, this.scrollWidth);
			console.dir(this.parentNode, this.offsetLeft);
			// .parentNode.parentNode
			// $(this).closest('ul').scrollLeft(this.offsetLeft);
			// $(this).closest('ul').animate({scrollLeft: this.offsetLeft}, 600);
			// console.log($(this).closest('ul').width(), this.offsetWidth);
			$(this).closest('ul').animate({scrollLeft: this.offsetLeft - ($(this).closest('ul').width() - this.offsetWidth) / 2}, 600);
			setTimeout(() => this.focus(), 1000);
		})
	})
}
module.exports = Tabs;



// WEBPACK FOOTER //
// ./libs/tabs.js